import type Immutable from 'immutable';
import { createMigration } from './utils';

function migrateGraphic(map: Immutable.Map<string, any>, path: (string | number)[]) {
    const graphic = map.getIn(path) as Immutable.Map<string, any> | undefined;
    if (
        graphic &&
        graphic.has('graphic') &&
        graphic.get('graphic') === 'box' &&
        graphic.has('shape') &&
        graphic.get('shape').get('boxHeight') === 'height (without descent)'
    ) {
        map.setIn([...path, 'shape', 'boxHeight'], 'height');
    }
}

function migrateAsset(someParentNode: Immutable.Map<string, any>, path: (string | number)[]) {
    const asset = someParentNode.getIn(path) as Immutable.Map<string, any> | undefined;
    if (asset && asset.has('colorGraphics')) {
        const graphics = (asset.get('colorGraphics') as Immutable.List<any>) || [];
        graphics.forEach((_, ind) => {
            migrateGraphic(someParentNode, [...path, 'colorGraphics', ind]);
        });
    }
}

export const migrationTo9_237 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations((map) => {
            if (map.has('mediaAsset')) {
                migrateAsset(map, ['mediaAsset']);
            }
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            if (map.has('children')) {
                const children = map.get('children') as Immutable.List<any>;
                children.forEach((_, i) => {
                    migrateAsset(map, ['children', i]);
                });
            }
            if (map.has('stickers')) {
                const stickers = map.get('stickers') as Immutable.List<any>;
                stickers.forEach((_, i) => {
                    migrateAsset(map, ['stickers', i]);
                });
            }
            if (map.has('subslides')) {
                const subslides = map.get('subslides') as Immutable.List<any>;
                subslides.forEach((subslide: Immutable.Map<string, any>, i) => {
                    if (subslide.has('children')) {
                        const children = subslide.get('children') as Immutable.List<any>;
                        children.forEach((_, j) => {
                            migrateAsset(map, ['subslides', i, 'children', j]);
                        });
                    }
                });
            }
        });
    },
});
